import { render, staticRenderFns } from "./inputtext.vue?vue&type=template&id=1489b12d&"
import script from "./inputtext.js?vue&type=script&lang=js&"
export * from "./inputtext.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1489b12d')) {
      api.createRecord('1489b12d', component.options)
    } else {
      api.reload('1489b12d', component.options)
    }
    module.hot.accept("./inputtext.vue?vue&type=template&id=1489b12d&", function () {
      api.rerender('1489b12d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/inputtext.vue"
export default component.exports